import { render } from "./Catalog.vue?vue&type=template&id=fc9cce0a"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Catalog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fc9cce0a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fc9cce0a', __exports__)) {
    api.reload('fc9cce0a', __exports__)
  }
  
  module.hot.accept("./Catalog.vue?vue&type=template&id=fc9cce0a", () => {
    api.rerender('fc9cce0a', render)
  })

}


export default __exports__